import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const MIN_SPLASH_MS = 3000;
const MAX_SPLASH_MS = 8000;

const Loading = ({ skintone, initialDataLoaded }) => {
    const [minDurationDone, setMinDurationDone] = useState(false);
    const timerStartedRef = useRef(false);

    useEffect(() => {
        if (!timerStartedRef.current) {
            timerStartedRef.current = true;
            const minTimer = setTimeout(() => setMinDurationDone(true), MIN_SPLASH_MS);
            const failSafe = setTimeout(() => setMinDurationDone(true), MAX_SPLASH_MS);
            return () => {
                clearTimeout(minTimer);
                clearTimeout(failSafe);
            };
        }
    }, []);

    const showSplash = !initialDataLoaded || !minDurationDone;

    if (!showSplash) return null;

    return (
        <div className={`loader loading ${skintone ? 'skintone' : ''}`}>
            <h2>
                Create your own
                <span>
                    Unique
                    <br />
                    Minifig
                </span>
            </h2>
            <img
                src="//minifigs-dev.myshopify.com/cdn/shop/files/Homepage_gif_-_15_November_large.gif?v=1668507196"
                alt=""
                className="loader-gif"
            />
            <img src="https://cdn.shopify.com/s/files/1/0223/5446/0736/files/load_1.svg?v=1758706117" alt="Loading" />
        </div>
    );
};

Loading.propTypes = {
    skintone: PropTypes.string,
    initialDataLoaded: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    skintone: state.builds[state.currentBuildIndex]?.skintone,
    initialDataLoaded: state.initialDataLoaded,
});

export default connect(mapStateToProps)(Loading);
